import * as Sentry from '@sentry/nextjs';

import { USER_SUCCESS } from 'dux/user/actionTypes';

// send each action type as Sentry breadcrumb
// get and send state and lastAction on exception

const sentry = store => {
  Sentry.configureScope(scope => {
    scope.addEventProcessor(event => {
      return {
        ...event,
        extra: {
          ...event.extra,
          'redux:state': store.getState(),
        },
      };
    });
  });

  return next => action => {
    if (action.type === USER_SUCCESS) {
      Sentry.configureScope(scope => {
        scope.setUser({
          id: action.user && action.user.pubkey,
          email: action.user && action.user.email,
        });
      });
    }

    Sentry.addBreadcrumb({
      category: 'redux-action',
      message: action.type,
    });

    Sentry.configureScope(scope => {
      scope.setExtra('redux:lastAction', action);
    });

    return next(action);
  };
};

export default sentry;
